export default __webpack_public_path__ + "static/media/harel.ccb7a205.svg";